import { useTranslation } from "react-i18next";
import PropsTypes from "prop-types";

import {
  Modal,
  ModalFooter,
  ModalImage,
  ModalText,
} from "shared/components/Modals/Modal";

import stylesModal from "@platformAssets/components/Modal.module.scss";

import icoWebCam from "assets/shared/img/ico__webcam_disable.svg";

const WebCamErrorModal = ({ close, tryAgain }) => {
  const { t } = useTranslation("profile");

  return (
    <Modal close={close} withPortal>
      <ModalImage src={icoWebCam} />
      <ModalText text={t("profile.webcam.error.title")} isTitle={true} />
      <ModalText text={t("profile.webcam.error.dsc")} />
      <ModalFooter>
        <button className={`${stylesModal.primaryButton}`} onClick={tryAgain}>
          {t("common:btnText.tryAgain")}
        </button>
        <button className={`${stylesModal.defaultButton}`} onClick={close}>
          {t("common:btnText.Cancel")}
        </button>
      </ModalFooter>
    </Modal>
  );
};

WebCamErrorModal.propTypes = {
  close: PropsTypes.func.isRequired,
  tryAgain: PropsTypes.func.isRequired,
};
export default WebCamErrorModal;
